/**
 * @generated SignedSource<<3abceba89209f8075110d4843e575c04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type getProvidersAutocompleteQuery$variables = {};
export type getProvidersAutocompleteQuery$data = {
  readonly sys_providers: ReadonlyArray<{
    readonly provider_id: number;
    readonly provider_name: string;
  }>;
};
export type getProvidersAutocompleteQuery = {
  response: getProvidersAutocompleteQuery$data;
  variables: getProvidersAutocompleteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "order_by",
        "value": {
          "provider_name": "asc"
        }
      }
    ],
    "concreteType": "sys_providers",
    "kind": "LinkedField",
    "name": "sys_providers",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider_name",
        "storageKey": null
      }
    ],
    "storageKey": "sys_providers(order_by:{\"provider_name\":\"asc\"})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "getProvidersAutocompleteQuery",
    "selections": (v0/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "getProvidersAutocompleteQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "90c23dd253c7e4e5a6d282b19fbc329e",
    "id": null,
    "metadata": {},
    "name": "getProvidersAutocompleteQuery",
    "operationKind": "query",
    "text": "query getProvidersAutocompleteQuery {\n  sys_providers(order_by: {provider_name: asc}) {\n    provider_id\n    provider_name\n  }\n}\n"
  }
};
})();

(node as any).hash = "2eea33b49a57302e43393330bc5689c0";

export default node;
